import { errorLogger } from '../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../store'
import { LoadingTypes, startLoading, stopLoading } from '@labrav/common'

import { camelize } from 'casing'
import { AwsAccountIDs } from './reducer'
import { fetchWAFRAWSAccounts } from '../../api/cloudfaas/wafr'

export enum WAFRCreateAssessmentForm {
  ADD_AWS_ACCOUNT_IDS = 'ADD_AWS_ACCOUNT_IDS',
}

export const setAWSAccountIDs = (payload: AwsAccountIDs[]) => ({
  type: WAFRCreateAssessmentForm.ADD_AWS_ACCOUNT_IDS,
  payload,
})

export const getAWSAccountIDs =
  (partnerId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      const response = await fetchWAFRAWSAccounts(partnerId)
      if (response?.data) {
        const awsAccountIDsResponse = camelize(response?.data)

        await dispatch(
          setAWSAccountIDs(awsAccountIDsResponse as AwsAccountIDs[])
        )
      }
    } catch (error: any) {
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }
